import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmPasswordDialogComponent } from './confirm-password-dialog.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { PasswordVisibilityToggleModule } from '@go-modules/directives/password-visibility-toggle/password-visibility-toggle.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		GoMaterialModule,
		FocusOnFirstInvalidFieldModule,
		PasswordVisibilityToggleModule
	],
	declarations: [
		ConfirmPasswordDialogComponent
	],
	exports: [
		ConfirmPasswordDialogComponent
	]
})
export class ConfirmPasswordDialogModule {}
